<h2 mat-dialog-title style="margin:0 0 8px 0;">Create License</h2>
<div mat-dialog-content style="padding-top: 8px;">
  <mat-form-field appearance="outline" class="w-100 mb-2">
    <mat-label>Purchase Email</mat-label>
    <input matInput [(ngModel)]="purchaseEmail" placeholder="name&#64;example.com" required pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$">
    <mat-hint>Format: name&#64;example.com</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100 mb-2">
    <mat-label>Product Id</mat-label>
    <mat-select [(ngModel)]="productId" required>
      <mat-option value="ntrip-pro">ntrip-pro</mat-option>
      <mat-option value="ntrip-ent">ntrip-ent</mat-option>
      <mat-option value="analyzer">analyzer</mat-option>
      <mat-option value="ntrip-basic">ntrip-basic</mat-option>
      <mat-option value="analyzer-pro">analyzer-pro</mat-option>
      <mat-option value="downloader-pro">downloader-pro</mat-option>
      <mat-option value="downloader">downloader</mat-option>
      <mat-option value="demo">demo</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="row g-2 mb-1">
    <div class="col-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Period</mat-label>
        <input matInput type="number" [(ngModel)]="period" min="1" required>
      <mat-hint>Positive integer</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Period Type</mat-label>
        <mat-select [(ngModel)]="periodType" required>
          <mat-option value="D">D</mat-option>
          <mat-option value="M">M</mat-option>
          <mat-option value="Y">Y</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end" style="gap:8px; margin-top:6px;">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="create()">Create</button>
</div>


